import { render, staticRenderFns } from "./wordcloud.vue?vue&type=template&id=0d8e49e3"
import script from "./wordcloud.vue?vue&type=script&lang=js"
export * from "./wordcloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports